import React, { createContext, useContext,useState ,useReducer } from 'react'
import {cartReducer,productReducer} from "./Reducers"


const InCart=createContext();

const Context = ({children}) => {
const [handleCart,setHandleCart]=useState([]);
const [item,setItem]=useState({});
// const [total,setTotal]=useState();
// const [restInfo,setRestInfo]=useState({});
//console.log(item)
//const [state,dispatch]=useReducer(cartReducer,{products:item,box:[],});

const [state, dispatch] = useReducer(cartReducer, {
  // products: restInfo,
  cart: [],
  
});


  return (
    
        <InCart.Provider  value={{state, dispatch,handleCart,setHandleCart,item,setItem}}>
            {children}
        </InCart.Provider>
     
  )
}



// export const CartState=()=>{
//     return useContext(InCart);
// };

// ,state,dispatch

export const CartState = () => {
  return useContext(InCart);
};

export default Context